import { useContext } from "react";

import { GetProjectDetailsResponse as GetPublicProjectDetailsResponse } from "../../../../../../service/publicquery";
import { GetProjectDetailsResponse } from "../../../../../../service/query";
import { ProjectContext } from "../../ProjectContext";

interface UseInventoryTabWithPreAccessReturnData {
  projectDetails: GetProjectDetailsResponse | undefined;
  publicProjectDetails: GetPublicProjectDetailsResponse | undefined;
}

export const useInventoryTabWithPreAccess = (): UseInventoryTabWithPreAccessReturnData => {
  const { projectDetails, publicProjectDetails } = useContext(ProjectContext);

  return {
    projectDetails,
    publicProjectDetails,
  };
};
